import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/book/$bookId/editor")({
  component: lazyRouteComponent(
    () => import("../pages/Book/BookEditorPage"),
    "BookEditorPage",
  ),
});
